<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Vendor" title="Raw Materials" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="row mb-4">
                                <div class="col-md-8">
									<div class="mm-cart-text">
										<div class="col-md-6">
											<table class="product_table">
												<thead style="font-size: medium;">
													<tr>
														<th>Vendor Name</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: right;">{{vendor.name}}</td>
													</tr> 
												</thead>
											</table>
										</div>
                                    </div>
								</div>
								<div class="col-md-2 float-end">
									<div class="btn btn-info" @click="openUploadStockModal()">Upload Stock Excel</div>
								</div>
							    <div class="col-md-2">
                                    <router-link :to="{ name: 'add_vendor_material', params: { id: $route.params.id } }" class="btn btn-primary float-end">Add Raw Material</router-link>
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchRawMaterials()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="200">200</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchRawMaterials()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Material</th>
											<th>Stock</th>
											<th>Quantity For Board</th>
											<th>Last Updated On</th> 
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(vendorRawMaterials.length)">
                                        <tr align="center" v-for="(material, index) in vendorRawMaterials" :key="material.id">
                                            <td>{{index + 1}}</td>
                                            <td>
												{{material.raw_material_name}}
											</td>
											<td>{{material.stock}}</td>
											<td>{{material.required_qty}}</td>
											<td>{{material.converted_updated_at}}</td>
											<td>
												<button class="btn btn-info btn-sm me-2 mb-2" @click="updateStock(material)">Update Stock</button><br>                
												<router-link :to="{ name: 'vendor_material_logs', params: { vendor_id: $route.params.id, raw_material_id: material.raw_material_id } }" class="btn btn-primary btn-sm me-2 mb-2">Stock Logs</router-link>
											</td>
                                        </tr>
                                      
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(vendorRawMaterials.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchRawMaterials(page.url + '&limit=' + listing_length + '&vendor_id=' + this.$route.params.id + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="updateStockMaterial" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="type">
								<option value="">--Select--</option>
								<option value="1">Add Stock</option>
								<option value="2">Remove Stock</option>
							</select>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Stock<span class="text-danger">*</span></label>
                        	<input v-model="stock" class="form-control" rows="3"/>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Upload Stock Excel Modal -->
		<div class="modal fade" id="uploadStockExcelModal" tabindex="-1" aria-labelledby="uploadStockExcelModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="uploadStockExcelModalLabel">Upload Excel</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeUploadStockModal"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitUploadStockExcel" enctype="multipart/form-data">
							<div class="row mt-3">
								<div class="col-md-12 form-group">
									<input class="form-control" type="file" accept=".xls, .xlsx" @change="onStockExcelFileChange" ref="stockExcelFileInput" />
									<small class="text-muted">Accepted formats: .xls, .xlsx</small>
									<div v-if="uploadError" class="text-danger mt-1">{{ uploadError }}</div>
									<div v-if="selectedStockExcelFile" class="mt-2">
										Selected file: {{ selectedStockExcelFile.name }}
									</div>
								</div>
							</div>
							<div class="col-md-12 form-group mt-3">
								<button type="submit" class="btn btn-primary me-3" :disabled="!selectedStockExcelFile || isUploadingStockExcel">
									<span v-if="isUploadingStockExcel">Uploading...</span>
									<span v-else>Upload</span>
								</button>
								<button type="button" class="btn btn-light" @click="closeUploadStockModal">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				
				modal_title: "Update Stock",
				button_title: "Update",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

				vendorRawMaterials:[],
				vendor:{},
				selected_material_id: null,

                type: "1",
				stock: "",

				selectedStockExcelFile: null,
				uploadStockExcelModalInstance: null,
				isUploadingStockExcel: false,
				uploadError: null,
			};
		},
		mounted() {
			this.$nextTick(() => {
				const el = document.getElementById('uploadStockExcelModal');
				if (el) this.uploadStockExcelModalInstance = new Modal(el);
			});
		},
		created() {
			this.fetchRawMaterials();
		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchRawMaterials(page_url = null) {
				this.getToken();
				let url = "/staffs/vendorRawMaterialList?limit=" + this.listing_length  + "&vendor_id=" + this.$route.params.id + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vendor = responseData.vendor;
						this.vendorRawMaterials = responseData.vendorRawMaterials.data;
						this.pagination = responseData.vendorRawMaterials.links;
						this.from = responseData.vendorRawMaterials.from;
						this.to = responseData.vendorRawMaterials.to;
						this.total = responseData.vendorRawMaterials.total;
						
					})
					.catch((err) => console.log(err));
			},

			
			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

			
			updateStock(material) {
				this.errors = {};
				this.modal_title = "Update Stock";
				this.button_title = "Update";
				this.selected_material_id = material.raw_material_id;
				this.type = "1";
				this.stock = "";
				this.showModal();
			},

			updateStockMaterial() 
			{
				this.getToken();
				let formData = new FormData();
                formData.append("vendor_id", this.$route.params.id);
                formData.append("raw_material_id", this.selected_material_id);
				formData.append("type", this.type);
                formData.append("stock", this.stock);

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url = "/staffs/updateVendorRawMaterialStock";
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.hideModal();
						this.fetchRawMaterials();
						this.clearForm();
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								// Handle validation errors (object) or simple error messages (string)
								let errorMessage = error.response.data.message;
								if (typeof errorMessage === 'object' && !Array.isArray(errorMessage)) {
									// Format validation errors into readable string
									const errorArray = [];
									for (let field in errorMessage) {
										if (Array.isArray(errorMessage[field])) {
											errorArray.push(...errorMessage[field]);
										} else {
											errorArray.push(errorMessage[field]);
										}
									}
									errorMessage = errorArray.join('<br>');
								}
								this.$swal("", errorMessage, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.edit = false;
				this.selected_material_id = null;
				this.type = "1";
				this.stock = "";
				this.modal_title = "Update Stock";
				this.button_title = "Update";
				this.errors = {};
			},

			openUploadStockModal() {
				this.selectedStockExcelFile = null;
				this.uploadError = null;
				if (this.$refs.stockExcelFileInput) this.$refs.stockExcelFileInput.value = "";
				if (this.uploadStockExcelModalInstance) this.uploadStockExcelModalInstance.show();
			},

			closeUploadStockModal() {
				if (this.uploadStockExcelModalInstance) this.uploadStockExcelModalInstance.hide();
				this.selectedStockExcelFile = null;
				this.uploadError = null;
				this.isUploadingStockExcel = false;
				if (this.$refs.stockExcelFileInput) this.$refs.stockExcelFileInput.value = "";
			},

			onStockExcelFileChange(event) {
				const file = event.target.files && event.target.files[0];
				if (file) {
					if (!file.name.match(/\.(xls|xlsx)$/)) {
						this.uploadError = "Please select an Excel file (.xls or .xlsx)";
						this.selectedStockExcelFile = null;
						return;
					}
					this.selectedStockExcelFile = file;
					this.uploadError = null;
				} else {
					this.selectedStockExcelFile = null;
					this.uploadError = null;
				}
			},

			submitUploadStockExcel() {
				if (!this.selectedStockExcelFile) {
					this.uploadError = "Please select a file first";
					return;
				}
				this.uploadStockExcel(this.selectedStockExcelFile);
			},

			uploadStockExcel(file) {
				if (!file) {
					this.$swal("", "Please select a file", "error");
					return;
				}
				this.getToken();
				const formData = new FormData();
				formData.append("vendor_id", this.$route.params.id);
				formData.append("file", file);
				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
				};
				this.isUploadingStockExcel = true;
				this.uploadError = null;
				this.$axios
					.post("/staffs/importVendorStock", formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message || "Stock imported successfully", "success");
							this.closeUploadStockModal();
							this.fetchRawMaterials();
						} else {
							this.$swal("", response.data.message || "Import failed", "error");
						}
					})
					.catch((err) => {
						console.error(err);
						this.uploadError = err.response && err.response.data && err.response.data.message
							? err.response.data.message
							: "Failed to upload Excel";
						this.$swal("", this.uploadError, "error");
					})
					.finally(() => {
						this.isUploadingStockExcel = false;
					});
			},


		},
	};
</script>